export const setTitle = (title: string): void => {
  document.title = `${title} | Kata CMS`;
};
